module.exports = __webpack_public_path__ + "static/img/article-5-flat.a354801.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/article-5-flat.jpg
// module id = prVR
// module chunks = 1